<template>
  <div class="common">
    <a-tabs v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :tabType="item.key" :gldStCds="item.gldStCds"
            :goldStatusOptions="item.goldStatusOptions" :estb="userObj.cstIds.join(',')" :pypt="userObj.cstIds.join(',')"
            :columnsSource="item.columns" :formSource="item.form" :fromTypeRouter="item.fromType" formType="goldenbill"
            fromPath='inquiry/goldenbill' :pageType="item.pageType"></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import goldPage from "@/components/gold-page/gold-page"
export default {
  components: {
    goldPage
  },
  name: "goldenbill",
  data() {
    return {
      tabData: [
        {
          name: "祺信查询",
          key: "goldSearch",
          comp: goldPage,
          fromType: "3",
          gldStCds: "1,6",
          pageType: "GldQuery",
          goldStatusOptions: [{ name: "已签收", value: 1 }, { name: "已结清", value: 6 }],
          columns: ["祺信编号", "担保方", "接收方", "祺信面额(元)", "开立日期", "到期日期", "剩余天数", "变更状态", "祺信状态", "是否逾期", "有无发票", "祺信变更",],
          form: ["开立日期", "祺信编号", "接收方", "到期日期", "变更状态", "是否逾期", "祺信状态"]
        }
      ],
      tabCur: "goldSearch"
    }
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"

    })
  },
  created() {

  },
  mounted() {

  },
  methods: {


  },
  activated() {

  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/inquiry/goldenbill.vue